import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WebsocketService {
  public socket;
  public endpoint = environment.API_SOCKET;
  public path = environment.SOCKET_PATH;
  public plotId: string;

  constructor() {}

  connect(): Subject<MessageEvent> {
    const token = sessionStorage.getItem('access_token'); // or from your AuthService

    this.socket = io(this.endpoint, {
        path: this.path,
        transports: ['websocket'], // บังคับใช้ polling
        query: {
          token: token, // send token in query
        },
    });

    const observable = new Observable((observer) => {
      this.socket.on('socket_io', (data) => {
        observer.next(data);
      });

      // Optionally handle connection events
      this.socket.on('connect_error', (err) => {
        console.error('Socket connection error:', err);
      });
    });

    const observer = {
      next: (data) => {
        this.plotId = data.plotId;
        this.socket.emit('joinroom', data);
        this.socket.emit('socket_io', JSON.stringify(data));
      },
    };

    return Subject.create(observer, observable);
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}
